/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoSfrIcon16Regular = forwardRef('GovKoSfrIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.8 1.382a.75.75 0 0 1 .193 1.043l-1.375 2A.75.75 0 0 1 7 4.75H4.75a2.5 2.5 0 0 0 0 5h.508a.19.19 0 0 0 .156-.082l3.94-5.69a1.69 1.69 0 0 1 1.388-.728h.508a4 4 0 0 1 0 8H9.393L7.19 14.427a.75.75 0 1 1-1.232-.854l2.425-3.5A.75.75 0 0 1 9 9.75h2.25a2.5 2.5 0 0 0 0-5h-.508a.19.19 0 0 0-.156.082l-3.94 5.69a1.69 1.69 0 0 1-1.388.728H4.75a4 4 0 1 1 0-8h1.855l1.152-1.675A.75.75 0 0 1 8.8 1.382Z" })));
});
